import styled, { css } from 'styled-components';
import { Link } from 'react-resource-router';
import { ActionButton } from '@fluentui/react/lib/Button';
import { forLargeDevices, forExtraSmallDevices } from '@pole-journal-web/app-theme';

const HEADER_HEIGHT = 50;
const HEADER_PADDING = 10;
export const USER_AVATAR_SIZE = HEADER_HEIGHT - HEADER_PADDING * 2;
export const LOGO_SIZE = USER_AVATAR_SIZE - 5;

export const commonContentPositionStyle = css`
    width: 100%;
    max-width: 1000px;
    position: relative;
    margin: 0 auto;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
`;

export const ScreenRoot = styled.div`
    display: flex;
    flex-direction: row;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
`;

export const Screen = styled.div`
    background-color: ${({ theme: { colors: { background } } }) => background};
    display: flex;
    flex-direction: column;
    flex: 1 0 100%;

    ${forLargeDevices('width: 100%;')}
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: ${({ theme: { colors: { primary } } }) => primary};
    box-shadow: ${({ hasBorderBottom }) => hasBorderBottom ? '0 0 2px black' : 'none'};
    height: ${HEADER_HEIGHT}px;
    padding: ${HEADER_PADDING}px;
    box-sizing: border-box;
    z-index: 1;
`;

export const HeaderBrand = styled(Link)`
    display: flex;
    flex-direction: row;
    color: ${({ theme: { colors: { primaryAlt } } }) => primaryAlt};
    text-decoration: none;
    
    &:hover {
        color: ${({ theme: { colors: { primaryAlt } } }) => primaryAlt};
    }
`;

export const HeaderLogo = styled.img`
    height: ${LOGO_SIZE}px;
`;

export const HeaderText = styled.div`
    font-size: ${LOGO_SIZE}px;
    line-height: ${LOGO_SIZE}px;
    margin-left: 10px;
    font-weight: 600;
`;

export const HeaderProfileButtonWrapper = styled.div`
    width: ${USER_AVATAR_SIZE}px;
    height: ${USER_AVATAR_SIZE}px;
`;

export const HeaderProfileButton = styled(ActionButton)`
    margin: 0;
    padding: 0;
    height: auto;
    border-radius: 0;
    border: 0px solid transparent;
`;

export const HeaderProfileSignIn = styled.div`
    width: ${USER_AVATAR_SIZE}px;
    height: ${USER_AVATAR_SIZE}px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: ${USER_AVATAR_SIZE / 2}px;
    background-color: ${({ theme }) => theme.colors.primary};
    border: ${({ theme }) => `2px solid ${theme.colors.primaryAlt}`};
`;

export const Content = styled.div`
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    -webkit-overflow-scrolling: touch;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
`;

export const FooterContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    background-color: ${({ theme: { colors: { primary } } }) => primary};
    color: ${({ theme: { colors: { primaryAlt } } }) => primaryAlt};
`;

export const AppDownloadButtonsRoot = styled.div`
    padding: 10px;
    background-color: ${({ theme }) => theme.colors.primaryAlt};
`;

export const AppDownloadButtonsContent = styled.div`
    ${commonContentPositionStyle};
    font-size: 16px;
    font-weight: 800;
    text-align: center;

    a {
        font-weight: 800;
    }
`;

export const Footer = styled.div`
    ${commonContentPositionStyle};
    display: flex;
    flex-direction: column;
    padding-top: 30px;
    padding-bottom: 30px;
    min-height: 380px;
`;

export const FooterRow = styled.div`
  display: flex;
  flex-direction: row;

  ${({ isFlex }) => forExtraSmallDevices(
        isFlex && 'flex-direction: column;'
    )}
`;

export const FooterColumn = styled.div`
    ${({ isFill }) => isFill && `
        flex: 1;
        align-items: center;
        justify-content: center;
        display: flex;
    `}

    &:not(:first-child) {
        margin-left: 100px;
    }

    ${({ isFlex }) => forExtraSmallDevices(
        isFlex && `
            &:not(:first-child) {
                margin-top: 20px;
                margin-left: 0;
            }
        `
    )}
`;

export const NavLinks = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const NavLink = styled(Link)`
    text-decoration: none;
    white-space:pre;
    color: inherit;
    &:hover {
        color: ${({ theme: { colors: { primaryAltHover } } }) => primaryAltHover};

        & > div {
            color: ${({ theme: { colors: { primaryAltHover } } }) => primaryAltHover}!important;
        }
    }
`;

export const Copyright = styled.div`
    text-decoration: none;
    margin-top: 40px;
`;

export const FooterSeparator = styled.div`
    background-color: ${({ theme: { colors: { primaryAlt } } }) => primaryAlt};
    height: 2px;
    margin-top: 20px;
    margin-bottom: 40px;
    width: 100%;
`;

export const Title = styled.div`
    font-size: 36px;
    ${forExtraSmallDevices(`
        font-size: 20px;
    `)}
`;
